import styled from 'styled-components';

export const Form = styled.form`
  .btn {
    font-size: 14px;
  }
`;
